var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserLoginIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 27,
    viewBox: "0 0 18 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-57 -525) translate(42 508) translate(15 17)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillOpacity: 0.87,
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9 11.263c1.114 0 2.335.162 3.665.486 1.509.377 2.73.88 3.664 1.508 1.114.737 1.671 1.563 1.671 2.48V18H0v-2.263c0-.917.557-1.743 1.67-2.48.935-.628 2.156-1.131 3.665-1.508 1.33-.324 2.551-.486 3.665-.486zM9 9c-.808 0-1.554-.202-2.237-.606-.682-.404-1.226-.948-1.63-1.63-.404-.683-.606-1.429-.606-2.237s.202-1.563.606-2.264c.404-.7.948-1.253 1.63-1.657C7.446.202 8.192 0 9 0s1.554.202 2.237.606c.682.404 1.226.957 1.63 1.657.404.701.606 1.456.606 2.264 0 .808-.202 1.554-.606 2.236-.404.683-.948 1.227-1.63 1.63C10.554 8.799 9.808 9 9 9z"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 20,
    r: 6,
    fill: "#FFF",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M11.34 23.674c.207 0 .386-.073.539-.22.152-.146.228-.322.228-.53v-3.821c0-.208-.076-.384-.228-.53-.153-.147-.332-.22-.54-.22h-.374v-.768c0-.348-.086-.668-.256-.96-.171-.293-.403-.524-.695-.695-.293-.17-.613-.256-.96-.256-.348 0-.668.085-.96.256-.293.17-.524.402-.695.695-.17.292-.256.612-.256.96v.768h-.375c-.207 0-.387.073-.54.22-.152.146-.228.322-.228.53v3.821c0 .208.076.384.229.53.152.147.332.22.539.22h4.571zm-1.107-5.321H7.874v-.768c0-.207.054-.402.16-.585.107-.183.252-.328.435-.435.182-.106.377-.16.585-.16.207 0 .402.054.585.16.183.107.327.252.434.435.107.183.16.378.16.585v.768zm-1.18 3.428c-.207 0-.386-.076-.539-.228-.152-.153-.228-.332-.228-.54 0-.207.076-.387.228-.539.153-.152.332-.229.54-.229.207 0 .387.077.54.229.152.152.228.332.228.54 0 .207-.076.386-.229.539-.152.152-.332.228-.54.228z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLoginIcon);
export default __webpack_public_path__ + "static/media/user_login_icon.d1cdb8b4a01a43b718d648929e2df3a2.svg";
export { ForwardRef as ReactComponent };